export default __webpack_public_path__ + "static/media/evolution-mono.ea2a5e78.svg";